export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-purple-50">
      {/* Hero Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Titre modeste */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              CV Viewer
            </h1>
            <p className="text-lg text-gray-600">
              Partage sécurisé de CV avec liens temporaires
            </p>
          </div>

          {/* FAQ Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 flex items-center">
              <span className="text-3xl mr-3">❓</span>
              Questions fréquentes
            </h2>
            
            <div className="space-y-6">
              {/* Question 1 */}
              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  Comment ça fonctionne ?
                </h3>
                <p className="text-gray-600">
                  Vous recevez un lien sécurisé par email contenant un token JWT. Ce lien vous permet de visualiser le CV pendant 2 heures. Après expiration, le lien devient invalide.
                </p>
              </div>

              {/* Question 2 */}
              <div className="border-l-4 border-purple-500 pl-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  Puis-je prolonger l'accès ?
                </h3>
                <p className="text-gray-600">
                  Oui ! L'administrateur peut prolonger votre accès de 48 heures supplémentaires depuis l'interface d'administration.
                </p>
              </div>

              {/* Question 3 */}
              <div className="border-l-4 border-pink-500 pl-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  Mes données sont-elles sécurisées ?
                </h3>
                <p className="text-gray-600">
                  Absolument. Chaque lien est unique, les accès sont tracés, et les tokens expirent automatiquement. Les données sont stockées de manière sécurisée.
                </p>
              </div>

              {/* Question 4 */}
              <div className="border-l-4 border-blue-500 pl-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  Puis-je télécharger le CV ?
                </h3>
                <p className="text-gray-600">
                  Si l'administrateur l'a autorisé, un bouton de téléchargement sera disponible. Le nom du fichier téléchargé peut être personnalisé.
                </p>
              </div>
            </div>
          </div>

          {/* Technologies & Hosting Section */}
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            {/* Technologies */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                <span className="text-2xl mr-2">⚙️</span>
                Technologies
              </h3>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  <strong className="mr-2">Backend:</strong> Node.js + Fastify
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  <strong className="mr-2">Frontend:</strong> React + Vite
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  <strong className="mr-2">Base de données:</strong> MariaDB
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  <strong className="mr-2">Auth:</strong> JWT (JSON Web Tokens)
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  <strong className="mr-2">PDF:</strong> PDF.js
                </li>
              </ul>
            </div>

            {/* Hosting */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                <span className="text-2xl mr-2">🚀</span>
                Développement local
              </h3>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-center">
                  <span className="text-blue-500 mr-2">🐳</span>
                  <strong className="mr-2">Docker:</strong> Conteneurisation
                </li>
                <li className="flex items-center">
                  <span className="text-blue-500 mr-2">📦</span>
                  <strong className="mr-2">Compose:</strong> Orchestration
                </li>
                <li className="flex items-center">
                  <span className="text-blue-500 mr-2">🔄</span>
                  <strong className="mr-2">Migrations:</strong> Automatiques
                </li>
                <li className="flex items-center">
                  <span className="text-blue-500 mr-2">📊</span>
                  <strong className="mr-2">Analytics:</strong> GoAccess
                </li>
              </ul>
            </div>
          </div>

          {/* Mise à jour Section */}
          <div className="bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl shadow-xl p-6 text-white">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div>
                <h3 className="text-xl font-bold mb-2 flex items-center">
                  <span className="text-2xl mr-2">⏱️</span>
                  Prolongation d'accès
                </h3>
                <p className="text-indigo-100">
                  Les liens peuvent être prolongés de <strong>48 heures</strong> par l'administrateur
                </p>
              </div>
              <div className="bg-white/20 backdrop-blur rounded-lg px-6 py-3">
                <div className="text-3xl font-bold">+48h</div>
                <div className="text-sm text-indigo-100">Extension possible</div>
              </div>
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-8 text-center text-gray-500 text-sm">
            <p>🔒 Tous les accès sont sécurisés et tracés pour votre protection</p>
          </div>
        </div>
      </div>
    </div>
  );
}
